import { Injectable } from '@angular/core';
import { collection, collectionData, CollectionReference, Firestore } from '@angular/fire/firestore';
interface Quote {
  image: string;
  name: string;
  podcast: string;
  quote: string;
}
@Injectable({
  providedIn: 'root',
})
export class QuoteService {
  constructor(private firestore: Firestore) {}

  getQuotes() {
    const quoteRef = collection(this.firestore, 'quotes') as CollectionReference<Quote>;
    return collectionData(quoteRef);
  }
}
